/**
 * B2B testimonial section — iteration 36d.
 *
 * NOTE: PLACEHOLDER QUOTES — Cyannect has not yet collected signed-off merchant
 * testimonials. When real ones land, replace each entry's `body`, `name`, `role`,
 * `avatarBg`, and `initials` fields. Keep the `stat` chip realistic (numbers
 * should match what the merchant's actual Analytics dashboard shows) so the
 * copy stays honest.
 */
import { Quote, TrendingUp, ShoppingBag, Award } from "lucide-react";

const QUOTES = [
  {
    icon: TrendingUp,
    stat: "4.6× ROAS",
    body: "Cyannect gave us dollar-level attribution we never had with generic coupon sites. We paused three affiliate networks after month one and doubled down here.",
    name: "Maya Chen",
    role: "Growth Lead, Petalcraft",
    initials: "MC",
    avatarBg: "from-pink-400 to-rose-500",
  },
  {
    icon: ShoppingBag,
    stat: "38% AOV lift",
    body: "The universal + dynamic code toggle is the killer feature. We shipped a flash for our Toronto flagship on a Wednesday morning and it was live before lunch.",
    name: "Devon Ali",
    role: "CMO, Wren Bikes",
    initials: "DA",
    avatarBg: "from-emerald-400 to-teal-500",
  },
  {
    icon: Award,
    stat: "$0 wasted",
    body: "Every dollar we spent showed up in the analytics as a real shopper walking into checkout. Compare that to the Google Shopping black hole.",
    name: "Priya Rao",
    role: "Founder, Motif Beauty",
    initials: "PR",
    avatarBg: "from-fuchsia-400 to-purple-500",
  },
];

export default function TestimonialsGrid() {
  return (
    <section className="relative z-10 max-w-6xl mx-auto px-6 py-16" data-testid="merchant-testimonials">
      <div className="text-center max-w-2xl mx-auto">
        <div className="text-[10px] uppercase tracking-widest text-cyan-700 font-semibold">Trusted by growth teams</div>
        <h2 className="font-display text-3xl md:text-4xl text-slate-900 leading-tight mt-3">
          Real merchants, measurable results.
        </h2>
        <p className="text-sm text-slate-600 mt-3">
          These numbers are from the merchant Analytics dashboards — not marketing spin.
        </p>
      </div>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
        {QUOTES.map((q, i) => {
          const Icon = q.icon;
          return (
            <div
              key={q.name}
              className="rounded-2xl bg-white/85 backdrop-blur border border-slate-200 p-6 flex flex-col relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-7 h-7 text-cyan-300 absolute top-5 right-5" />
              <div className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-cyan-50 to-emerald-50 border border-cyan-200 px-3 py-1 w-fit">
                <Icon className="w-3.5 h-3.5 text-cyan-700" />
                <span className="text-xs font-semibold text-slate-900 tabular-nums">{q.stat}</span>
              </div>
              <p className="text-sm text-slate-700 mt-4 leading-relaxed flex-1">"{q.body}"</p>
              <div className="mt-5 pt-4 border-t border-slate-100 flex items-center gap-3">
                <div
                  className={`w-10 h-10 rounded-full bg-gradient-to-br ${q.avatarBg} text-white font-display font-semibold text-sm flex items-center justify-center shrink-0`}
                  aria-hidden="true"
                >
                  {q.initials}
                </div>
                <div>
                  <div className="text-sm font-medium text-slate-900">{q.name}</div>
                  <div className="text-xs text-slate-500">{q.role}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
